import { NgModule } from '@angular/core';
import { LocalLayoutStorageService } from './local/layout.repo.service';

@NgModule({
    imports: [],
    providers: [LocalLayoutStorageService]
})
export class SharedDataStoreModule {}
